import { get, patch } from "./_client";

export type UserProfile = {
  id: string;
  name: string;
  email: string;
  image: string | null;
  emailVerified: boolean;
  phoneNumber: string | null;
  phoneNumberVerified: boolean;
  twoFactorEnabled: boolean;
  isSsoUser: boolean;
  language: string | null;
  title: string | null;
  signature: string | null;
  tenantName: string;
  defaultLanguage: string;
  supportedLanguages: string[];
};

export function getProfile() {
  return get<UserProfile>("/internal/profile");
}

export function updateProfile(data: {
  name: string;
  phoneNumber?: string;
  language?: string;
  title?: string;
  signature?: string;
}) {
  return patch<{ success: boolean }>("/internal/profile", data);
}
